import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-white font-heading font-bold text-xl">壹</span>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">壹号娱乐</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              壹号娱乐是您值得信赖的综合娱乐平台，提供多元化娱乐内容与极致体验服务。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#wechat" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-wechat-line text-sm text-background-200"></i>
              </a>
              <a href="#weibo" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-weibo-line text-sm text-background-200"></i>
              </a>
              <a href="#qq" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center cursor-pointer transition-colors duration-200">
                <i className="ri-qq-line text-sm text-background-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-5">
              <a href="/" className="hover:text-primary-400 transition-colors">娱乐分类</a>
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/category/live-casino', label: '真人娱乐' },
                { to: '/category/slots', label: '电子游艺' },
                { to: '/category/sports', label: '体育赛事' },
                { to: '/category/lottery', label: '彩票游戏' },
                { to: '/category/fishing', label: '捕鱼游戏' },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-5">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/about', label: '品牌介绍' },
                { to: '/about', label: '信誉资质' },
                { to: '/about', label: '联系我们' },
                { to: '/about', label: '社会责任' },
                { to: '/about', label: '用户协议' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-5">联系方式</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-3 text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>service@yihaoentertainment.com</span>
              </li>
              <li className="flex items-start gap-3 text-background-400">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                <span>7×24小时全天候服务</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2018-2026 壹号娱乐 版权所有
          </p>
          <div className="flex items-center gap-6 text-xs text-background-500">
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}